import React, { useState, useEffect } from "react";
import usuarioService from "../services/usuario.service";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';

const Login = () => {
    const [usuario, setUsuario] = useState('');
    let navigate = useNavigate();

    const handleUsuario = (valor, nombre) => {
        setUsuario({...usuario, [nombre]: valor});
    }

    const login = (e) => {
        e.preventDefault();
        console.log("Login ....", usuario);
        usuarioService.ingresar({correo: usuario.correo, password: usuario.password})
        .then(resp=>{
            console.log(resp);
            if(resp.data.accessToken) {
                localStorage.setItem("user", JSON.stringify(resp.data));
                navigate("/desvincular");
            }
        })
        .catch(err=>{
            console.error(err);
            console.log(err.response.data.message);
            toast.error(err.response.data.message);
        });
    }

    return (
        <div className="container">
            <Toaster />
            <div className="row justify-content-center">
                <div className="col-md-5">
                    <form onSubmit={login}>
                        <div className="mb-3">
                            <label className="form-label">Correo:</label>
                            <input type="text" className="form-control" onChange={(e)=>handleUsuario(e.target.value, "correo")} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Password:</label>
                            <input type="password" className="form-control" onChange={(e)=>handleUsuario(e.target.value, "password")} />
                        </div>
                        <div className="mb-3">
                            <button className="btn btn-primary">Log In</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;